import { motion } from "framer-motion";

const COLORS = ["#B91C1C", "#DC2626", "#25D366", "#c9a209", "#0369a1", "#7c3aed"];

export default function ChannelPerformanceChart({ channels }) {
  const rows = Array.isArray(channels) ? channels : [];
  const max = Math.max(1, ...rows.map((c) => Number(c.total || c.contacts || 0)));

  if (!rows.length) {
    return (
      <p className="flex min-h-[220px] flex-1 items-center justify-center text-sm text-primary/40">
        No outreach channel activity yet.
      </p>
    );
  }

  return (
    <div className="flex h-full min-h-[220px] flex-1 flex-col">
      <div className="flex flex-1 items-end justify-between gap-2 sm:gap-3">
        {rows.map((ch, i) => {
          const total = Number(ch.total || ch.contacts || 0);
          const height = Math.max(18, Math.round((total / max) * 100));
          return (
            <div key={ch.name || ch.channel || i} className="flex h-full min-w-0 flex-1 flex-col items-center">
              <div className="relative flex w-full flex-1 flex-col justify-end pb-1">
                <span className="mb-1 text-center text-[10px] font-bold text-primary">{total}</span>
                <motion.div
                  className="w-full origin-bottom rounded-t-xl"
                  style={{
                    height: `${height}%`,
                    minHeight: "18%",
                    backgroundColor: COLORS[i % COLORS.length],
                  }}
                  initial={{ scaleY: 0 }}
                  animate={{ scaleY: 1 }}
                  transition={{ duration: 0.65, delay: 0.1 + i * 0.1, ease: "easeOut" }}
                />
              </div>
              <div className="mt-2 w-full shrink-0 border-t border-primary/[0.06] pt-2 text-center">
                <p className="truncate text-[10px] font-medium leading-tight text-primary/55">
                  {ch.name || ch.channel || "Channel"}
                </p>
                <p className="mt-0.5 text-[10px] font-bold text-primary/80">{total} logged</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
